import React, { Component } from 'react';
import BCA from '../../../images/bca.png';
import cashlez from '../../../images/cashlez.png';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import AuthHelper from '../../../libraries/auth-helper';
import { history } from '../../../shared/configure-store';
import { toast, ToastContainer } from 'react-toastify';
import { withRouter, Link } from 'react-router-dom';
import Api from '../../../libraries/api';
import NumberFormat from 'react-number-format';
import language from '../../../libraries/label-lang';
import { bindActionCreators } from 'redux';
import { RootActions } from '../../../shared/root-action';
import { connect } from 'react-redux';
import SimpleReactValidator from 'simple-react-validator';
import templateId from "../../../libraries/lang-id";
import moment from "moment/moment";
import _ from 'lodash';
import ErrorHandling from "../../../libraries/error-handling";

SimpleReactValidator.addLocale('indo', templateId);

class Detail extends Component {

    constructor(props) {

        super(props);

        this.state = {
            loading: false,
            loadingButton: false,

            errors: [],

            amount: '',
            amountOther: '',
            daily: [],
            fulfillment: [],
            fulfillmentGroup: [],

            totalPricesDaily: 0,
            totalPricesFulfillment: 0,
            totalPrices: 0,
            totalTax: 0,
            totalAll: 0,
        };

        let lang = AuthHelper.getLang();

        this.validator = new SimpleReactValidator(
            {
                locale: lang
            }
        );

    }

    componentDidMount() {

        document.title = 'Fresh Factory - Detail Biaya';

        Api.get('/expenses_detail?transaction_date=' + this.props.match.params.date).then(resp => {
            if (resp.data) {

                let total = 0;
                let totalDaily = 0;
                let totalFull = 0;
                let tax = 0;


                _.forEach(resp.data.daily, function (v) {
                    total += parseFloat(v.total_prices);
                    totalDaily += parseFloat(v.total_prices);
                    tax += parseFloat(v.tax);
                });
                _.forEach(resp.data.fulfillment, function (v) {
                    total += parseFloat(v.total_prices);
                    totalFull += parseFloat(v.total_prices);
                    tax += parseFloat(v.tax);
                });

                this.setState({
                    daily: resp.data.daily ? resp.data.daily : [],
                    fulfillment: resp.data.fulfillment ? resp.data.fulfillment : [],
                    fulfillmentGroup: resp.data.fulfillmentGroup ? resp.data.fulfillmentGroup : [],
                    totalPrices: total,
                    totalPricesDaily: totalDaily,
                    totalPricesFulfillment: totalFull,
                    totalTax: tax,
                    totalAll: total + tax,
                    loading: false,
                });
            }
        }).catch(err => {
            console.log(err);

            this.setState({
                loading: true,
            }
            );

        });
    };

    handleChange(e, prop) {

        this.setState({
            amount: '',
            [prop]: e.target.value

        })

    };

    handleGo = (link) => {
        history.push(link);
    };

    showMessage = (status, message) => {
        if (status) {
            toast.success(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        } else {
            toast.error(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }
    };


    render() {
        let lang = {};
        if (this.props.toggle_set_lang === 'indo') {
            lang = language.id;
        } else {
            lang = language.en;
        }
        const text = lang;

        return (

            <div className='dashboard-detail'>
                <nav aria-label='breadcrumb'>
                    <ol className='breadcrumb'>
                        <li className='breadcrumb-item'><Link to='/' >{text.label_dashboard}</Link></li>
                        <li className='breadcrumb-item'><Link to='/histories' >{text.label_history}</Link></li>
                        <li className='breadcrumb-item'><Link to='/histories/list' >List</Link></li>
                        <li className='breadcrumb-item active' aria-current='page'>Detail Biaya</li>
                    </ol>
                </nav>
                <h2 className='text-uppercase'>Detail Biaya</h2>

                <div className='row'>
                    <div className='col-lg-10'>
                        <form className='card-white__dash mb-3'>
                            <small>Tanggal</small>
                            <p>{moment(this.props.match.params.date).format('DD MMM YYYY')}</p>
                            <div className='card-header grey'>
                                <h3 className='mb-0'>Biaya Sewa Harian</h3>
                            </div>
                            {
                                this.state.daily.length > 0 &&
                                this.state.daily.map((row, idx) => (
                                    <div className='row px-3' key={idx}>
                                        <div className='col-6 '>
                                            <p>{row.total} {row.iku_id} - {row.storage_id} - {row.name}</p>
                                        </div>
                                        <div className='col-6 text-right'>
                                            <p>
                                                Rp <NumberFormat thousandSeparator={'.'} decimalSeparator={','} value={row.total_prices} fixedDecimalScale={false} decimalScale={0} displayType={'text'} renderText={value => value} />
                                            </p>
                                        </div>
                                    </div>
                                ))
                            }
                            <div className='row px-3'>
                                <div className='col-6 '>
                                </div>
                                <div className='col-6 text-right'>
                                    <p>
                                        Total: Rp <NumberFormat thousandSeparator={'.'} decimalSeparator={','} fixedDecimalScale={false} value={this.state.totalPricesDaily} decimalScale={0} displayType={'text'} renderText={value => value} />
                                    </p>
                                </div>
                            </div>
                            <div className='card-header grey mt-3'>
                                <h3 className='mb-0'>Biaya Fulfilment</h3>
                            </div>

                            {
                                this.state.fulfillmentGroup.length > 0 &&

                                this.state.fulfillmentGroup.map((row, index) => (
                                    <div className='' key={index}>
                                        <div className=''>
                                            <p className='mb-0'>{row.id}</p>
                                        </div>
                                        {
                                            row.data.map((value, idx) => (
                                                <div className='row px-3' key={idx}>
                                                    <div className='col-6 '>
                                                        <p className='mb-0'>  {value.storage_id + ' / ' + value.name}</p>
                                                    </div>
                                                    <div className='col-6 text-right'>
                                                        <p>
                                                            Rp <NumberFormat thousandSeparator={'.'} decimalSeparator={','} value={value.total_prices} decimalScale={0} fixedDecimalScale={false} displayType={'text'} renderText={value => value} />
                                                        </p>
                                                    </div>
                                                </div>
                                            ))
                                        }
                                    </div>
                                ))
                            }
                            <div className='row px-3'>
                                <div className='col-6 '>
                                </div>
                                <div className='col-6 text-right'>
                                    <p>
                                        Total: Rp <NumberFormat thousandSeparator={'.'} decimalSeparator={','} fixedDecimalScale={false} value={this.state.totalPricesFulfillment} decimalScale={0} displayType={'text'} renderText={value => value} />
                                    </p>
                                </div>
                            </div>
                        </form>

                        <div className='card-white__blue'>
                            <div className='row px-3'>
                                <div className='col-6 '>
                                    <p className='mb-0'>Total Biaya</p>
                                </div>
                                <div className='col-6 text-right'>
                                    <p className='mb-0'>
                                        Rp <NumberFormat thousandSeparator={'.'} decimalSeparator={','} fixedDecimalScale={false} value={this.state.totalPrices} decimalScale={0} displayType={'text'} renderText={value => value} />
                                    </p>
                                </div>
                            </div>
                            <div className='row px-3 border-bottom'>
                                <div className='col-6 '>
                                    <p>PPN</p>
                                </div>
                                <div className='col-6 text-right'>
                                    <p>
                                        Rp <NumberFormat thousandSeparator={'.'} decimalSeparator={','} fixedDecimalScale={false} value={this.state.totalTax} displayType={'text'} renderText={value => value} />
                                    </p>
                                </div>
                            </div>
                            <div className='row px-3 pt-3'>
                                <div className='col-6 '>
                                    <p>Total Pembayaran</p>
                                </div>
                                <div className='col-6 text-right'>
                                    <p>
                                        Rp <NumberFormat thousandSeparator={'.'} decimalSeparator={','} fixedDecimalScale={false} value={this.state.totalAll} displayType={'text'} renderText={value => value} />
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <ToastContainer />
            </div>

        )

    }
}

const mapStateToProps = (state) => {

    return {

        toggle_set_lang: state.toggle_set_lang,

    };

};

const mapDispatchToProps = (dispatch) => {

    return bindActionCreators(RootActions, dispatch)

};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Detail));